import React, { Component } from 'react';
import { connect } from 'react-redux'
import derschlaueblaue from '../img/derschlaueblaue.jpg'
import { Link } from 'react-router-dom';

class Landing extends Component {

	componentDidMount() {

	}

	isAdmin() {
		if (this.props.auth) {
			return this.props.auth.roles && this.props.auth.roles.indexOf('admin') > -1;
		} else {
			return false;
		}

	}

	render() {

		return (
			<div style={{backgroundColor:'#fff',maxHeight:'800px', display:'table'}}>
				<div
					className="w-50"
					style={{ display:'table-cell', verticalAlign:'middle', backgroundColor:'#fff'}}>

					{!this.props.auth && <Link to="/login">Login für Fuhrparkleiter</Link>}

					{this.props.auth && <Link to="/fahrer">Angemeldete Fahrer</Link>}

					{this.isAdmin() && <React.Fragment>
						<span> | </span>
						<Link to="/user">User</Link>
					</React.Fragment>}

					{this.isAdmin() && <React.Fragment>
						<span> | </span>
						<Link to="/fahrerUndUser">Alle Fahrer</Link>
					</React.Fragment>}

					{this.props.auth && <React.Fragment>
						<span> | </span>
						<Link to="/prefs">Einstellungen</Link>
					</React.Fragment>}
					<br/>
					<React.Fragment>
						<Link to="/video/sehen/lasi">Video Ladungssicherung</Link>
					</React.Fragment>

					<React.Fragment>
						<span> | </span>
						<Link to="/video/sehen/fscheck">Video Führerscheinkontrolle</Link>
					</React.Fragment>


				</div>
				<div className="w-50" style={{display:'table-cell'}}>
					<img
						style={{display:'table-cell',width:'100%'}}
						src={derschlaueblaue} alt="der schlaue Blaue" />
				</div>
			</div>
		);
	}
};

function mapStateToProps({ auth }) {
	return { auth };
}

export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/components/Landing.js